import { render, staticRenderFns } from "./EntityGallery.vue?vue&type=template&id=0fb5f72c&scoped=true&"
import script from "./EntityGallery.vue?vue&type=script&lang=ts&"
export * from "./EntityGallery.vue?vue&type=script&lang=ts&"
import style0 from "./EntityGallery.vue?vue&type=style&index=0&id=0fb5f72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5f72c",
  null
  
)

export default component.exports